import { render } from "./MpkProjectStatuses.vue?vue&type=template&id=f674ca48"
import script from "./MpkProjectStatuses.vue?vue&type=script&lang=js"
export * from "./MpkProjectStatuses.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__